import React from 'react';
import { ChevronDown } from 'lucide-react';
import { FAQ_ITEMS } from '../../lib/structuredData';

// FAQ con <details>/<summary> nativos: el contenido siempre vive en el DOM
// (lo ve Google aunque esté colapsado y funciona sin JavaScript). El JSON-LD
// FAQPage se inyecta desde la home (mismo origen: FAQ_ITEMS).
const FaqSection = () => (
  <section id="faq" className="py-16 px-4 md:px-6 bg-cream">
    <div className="container mx-auto max-w-3xl">
      <h2 className="text-3xl md:text-4xl font-bold text-chocolate text-center mb-3">
        Preguntas frecuentes
      </h2>
      <p className="text-center text-chocolate-light mb-8">
        Todo lo que necesitas saber para pedir tus brazos gitanos en Quito.
      </p>

      <div className="space-y-3">
        {FAQ_ITEMS.map((item, i) => (
          <details
            key={i}
            className="group bg-white rounded-xl shadow-sm overflow-hidden"
          >
            <summary className="flex items-center justify-between gap-3 cursor-pointer list-none p-5 font-semibold text-chocolate min-h-[44px]">
              <span>{item.q}</span>
              <ChevronDown className="w-5 h-5 shrink-0 text-caramel transition-transform group-open:rotate-180" />
            </summary>
            <div className="px-5 pb-5 -mt-1 text-chocolate-light">{item.a}</div>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default FaqSection;
